import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import DateFnsUtils from "@date-io/date-fns";
import { TextField } from "@material-ui/core";
import dayjs from "dayjs";
export const DatePicker = ({
  label,
  value,
  error,
  required,
  onChange,
  fullWidth,
  variant,
  disablePast,
  disabled,
  ...rest
}) => {
  // const formatDate = (date) => {
  //   const d = dayjs(date,"yyyy-MM-dd");
  
  //   return [year, month, day].join('-');
  // };
  const today = new Date().toISOString().substring(0, 10); 
  return (
 
    <TextField
    required={required}
    label={label}
    type="date"
    placeholder="DD/MM/YYYY"
    disabled={disabled}
    value={value}//.format("dd/mm/yyyy")}
    // onChange={handleDateChange}
    InputProps={{
      inputProps: { min: disablePast?today:null }, // Disable dates before today
      // readOnly: true,
      onKeyDown:(e)=>e.preventDefault()
    }}
    InputLabelProps={{
      shrink: true,
      
    }}
    variant={variant?variant:"outlined"}
    size="small"
    onChange={(e)=>{
      onChange(e.target.value)}}
    fullWidth
    error={error}
    helperText={error}
    
  />
  );
};
